import React, { useContext, useEffect, useState } from 'react';
import AuthContext from '../../../authentication/AuthContext';
import UserContext from '../../../user/UserContext';
import axios from 'axios';
import moment from 'moment';

export default function DeliveryCutoffs() {
    let [cutoffs, setCutoffs] = useState([]);

    const cas = useContext(AuthContext);

    const { userDetails } = useContext(UserContext);

    useEffect(() => {
        if (
            userDetails.currentFranchise &&
            !(userDetails.currentFranchise.onHold && !userDetails.currentFranchise.payOnOrder) &&
            userDetails.currentFranchise.status !== 'Closed'
        ) {
            axios
                .get(
                    window.CONFIG['ws.activoc-web-order-api.nextDelivery.cutoff'].replace(
                        '{franchiseCode}',
                        userDetails.currentFranchise.code
                    ),
                    {
                        headers: {
                            Authorization: cas,
                            'Content-Type': 'application/json'
                        }
                    }
                )
                .then(response => {
                    setCutoffs(
                        response.data.deliveryDatesCutOff.map(cutoff => (
                            <p key={cutoff.supplierCode}>
                                <>{mapToReadableSupplier(cutoff.supplierCode)}: </>
                                <>{mapToTimeString(cutoff.cutOffDateTime)}</>
                            </p>
                        ))
                    );
                });
        }
    }, [cas, userDetails]);

    return (
        <div className={'delivery-cutoffs-wrapper flex'}>
            {userDetails.currentFranchise && cutoffs?.length > 0 && (
                <>
                    <div>Your Next Order Cutoffs:</div>
                    <div className={'delivery-cutoffs flex'}>{cutoffs}</div>
                </>
            )}
        </div>
    );
}

function mapToReadableSupplier(input) {
    switch (input) {
        case 'NISA':
            return 'Nisa Ambient';
        case 'NISAC':
            return 'Nisa Chill';
        default:
            return 'Nisa Freeze';
    }
}

function mapToTimeString(input) {
    return moment(input).format('DD/MM/YYYY HH:mm');
}
